import { Modal } from "@marekl/adminer/components";
import { PhotoUploadField } from "../../../components/PhotoUploadField";
import type { Person } from "../../../lib/queries/memberships";
import type { ID } from "../../../lib/id";

// The photo dialog, opened from the round chip at the head of a roster row.
//
// This is deliberately NOT a second edit surface for a Person — AGENTS.md
// keeps EditMemberModal as the single one, because two dialogs over one
// human is what once let a leader's role be silently dropped. It touches
// nothing but the photo: PhotoUploadField owns its own upload/remove
// mutation and is independent of any form submit, so there is no second set
// of identity fields here to drift from the first.
//
// Why it exists at all rather than reusing EditMemberModal: adding a face to
// a roster row should not mean opening a full identity-and-roles form, and
// the photo is exempt from the identity lock (it may be completed after the
// registration window closes), so the two have different rules anyway.

export interface PhotoModalProps {
  teamId: ID;
  person: Person;
  onClose: () => void;
}

export function PhotoModal({ teamId, person, onClose }: PhotoModalProps) {
  return (
    <Modal
      open
      title={`Fotka · ${person.first_name} ${person.last_name}`}
      onClose={onClose}
      width={420}
    >
      <PhotoUploadField
        teamId={teamId}
        personId={person.id}
        hasPhoto={person.photo_uploaded ?? false}
      />
    </Modal>
  );
}
